<template lang="pug">
  .sidebar(:class="{ open: openSidebar }")
    .search.search-agg
      .search-menu
        .search-title
          span 絞り込む
        .search-row
          span.search-label 集計内容
          label.radio
            input(type='radio' v-model="aggType" value="1")
            span 求人数
          label.radio
            input(type="radio" v-model="aggType" value="2" v-if="salaryCd !== '0'")
            input(type="radio" v-model="aggType" value="2" disabled v-else)
            span 給与
          label.radio
            input(type='radio' v-model="aggType" value="3")
            span 出稿予算
        .search-row
          span.search-label 集計縦軸
          label.radio
            input(type='radio' v-model="verticalAxis" value="5")
            span 都道府県
          label.radio
            input(type='radio' v-model="verticalAxis" value="1")
            span 市区町村
          label.radio
            input(type='radio' v-model="verticalAxis" value="2")
            span 職種
          label.radio
            input(type='radio' v-model="verticalAxis" value="3")
            span 業種
          label.radio
            input(type='radio' v-model="verticalAxis" value="4")
            span 掲載メディア
        .search-row
          span.search-label 集計期間(最大186日間)
          .acquisition-datepicker
            datepicker(
              v-model="aggregationFromDate"
              :format="customFormatter"
              :language="ja"
              :disabled-dates="disabledFromDates"
              wrapper-class="calender-text-box-wrapper"
              input-class="calender-text-box"
              @closed="pickerClosedChange"
            )
            span 〜
            datepicker(
              v-model="aggregationToDate"
              :format="customFormatter"
              :language="ja"
              :disabled-dates="disabledToDates"
              wrapper-class="calender-text-box-wrapper"
              input-class="calender-text-box"
              @closed="pickerClosedChange"
            )
          .time-shift
            a.time-shift-button(@click="prevSixMonths")
              | < 6ヶ月前
            a.time-shift-button(@click="nextSixMonths")
              | 6ヶ月後 >
        .search-row
          span.search-label 集計単位
          label.radio
            input(type='radio' v-model="rangeType" value="1")
            span 週次
          label.radio
            input(type='radio' v-model="rangeType" value="2")
            span 月次
        .search-row
          span.search-label 給与
          label.radio
            input(type="radio" value="0" v-model="salaryCd")
            span すべて
          br
          label.radio(v-for="salaryType in aggSalaryTypes")
            input(type="radio" :value="salaryType.code" v-model="salaryCd")
            span {{ salaryType.name }}
        .search-row
          span.search-label 掲載メディア
          MultipleSelect(v-model="mediaCd" :options="vSelectMedia")
        .search-row
          span.search-label 所在地
          .select-tree(:class="{ active: openPrefectureModal }")
            a.select-tree-button(
              @click="togglePrefectureModal"
              :class="{ active: openPrefectureModal }")
              | 選択する
            span.select-tree-selected(v-if="prefectureCd.length > 0 || cityCd.length > 0") 選択中
            PrefectureCityModal(
              :groupingPrefecture="true"
              :prefectures="this.$store.state.master.prefectures"
              :openPrefectureCityModal="openPrefectureModal"
              :selectedPrefectureCd="prefectureCd"
              :selectedCityCd="cityCd"
              @setPrefectures="setPrefectureCodes"
              @setPrefectureCities="setCityCodes"
              @hide="hidePrefectureModal")
        .search-row
          span.search-label 勤務地
          .select-tree(:class="{ active: openWorkPlacePrefectureModal }")
            a.select-tree-button(
              @click="toggleWorkPlacePrefectureModal"
              :class="{ active: openWorkPlacePrefectureModal }")
              | 選択する
            span.select-tree-selected(v-if="workPlacePrefectureCd.length > 0 || workPlaceCityCd.length > 0") 選択中
            PrefectureCityModal(
              :groupingPrefecture="true"
              :prefectures="this.$store.state.master.prefectures"
              :openPrefectureCityModal="openWorkPlacePrefectureModal"
              :selectedPrefectureCd="workPlacePrefectureCd"
              :selectedCityCd="workPlaceCityCd"
              @setPrefectures="setWorkPlacePrefectureCodes"
              @setPrefectureCities="setWorkPlaceCityCodes"
              @hide="hideWorkPlacePrefectureModal")
        .search-row
          span.search-label 職種
          .select-tree(:class="{ active: openJobtypeModal }")
            a.select-tree-button(
              @click="toggleJobtypeModal"
              :class="{ active: openJobtypeModal }")
              | 選択する
            span.select-tree-selected(v-if="jobtypeCd.length > 0") 選択中
            JobtypeModal(
              :openJobtypeModal="openJobtypeModal"
              :selectedJobtypeCd="this.$store.state.aggregateJob.query.jobtypeCd"
              :filteredAp="false"
              @setJobtypeCodes="setJobtypeCodes"
              @hide="hideJobtypeModal")
        .search-row
          span.search-label 業種
          MultipleSelect(v-model="industryCd" :options="vSelectIndustry")
        .search-row
          span.search-label 雇用形態
          MultipleSelect(v-model="employmentCd" :options="vSelectEmploymentCd")
        .search-row
          span.search-label キーワードその他({{ this.maxKeywords }}個まで)
          span.keyword-info 改行でキーワードを追加
          .keyword-tag-area
            .select-choice(:class="keyword.length > 0 ? 'open' : ''")
              ul.select-choice-selected
                li(v-for="(tag, index) in this.keyword")
                  div {{ tag }}
                  a.select-choice-delete(@click="removeKeyword(index)")
          label.text
            input(
              type="text"
              placeholder="例）仕事内容、資格など"
              @keydown="keydownCondition"
              @keyup.enter="keywordEnter($event)")
          span.search-label-sub 適用項目
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyKeywordsToCatchcopy"
              true-value="true"
              false-value="false")
            span キャッチコピー
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyKeywordsToJobtypeName"
              true-value="true"
              false-value="false")
            span 募集職種
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyKeywordsToJobContents"
              true-value="true"
              false-value="false")
            span 仕事内容
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyKeywordsToQualification"
              true-value="true"
              false-value="false")
            span 応募資格
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyKeywordsToCompanyName"
              true-value="true"
              false-value="false")
            span 事業所名
        .search-row
          span.search-label 除外キーワード({{ this.maxKeywords }}個まで)
          span.keyword-info 改行でキーワードを追加
          .keyword-tag-area
            .select-choice(:class="excludeKeyword.length > 0 ? 'open' : ''")
              ul.select-choice-selected
                li(v-for="(tag, index) in this.excludeKeyword")
                  div {{ tag }}
                  a.select-choice-delete(@click="removeExcludeKeyword(index)")
          label.text
            input(
              type="text"
              placeholder="例）除外したい仕事内容、資格など"
              @keydown="keydownCondition"
              @keyup.enter="excludeKeywordEnter($event)")
          .keyword
            a.keyword-button(@click="applyRecommendedExcludeKeywords")
              | おすすめキーワードを設定する
          span.search-label-sub 適用項目
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyExcludeKeywordsToCatchcopy"
              true-value="true"
              false-value="false")
            span キャッチコピー
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyExcludeKeywordsToJobtypeName"
              true-value="true"
              false-value="false")
            span 募集職種
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyExcludeKeywordsToJobContents"
              true-value="true"
              false-value="false")
            span 仕事内容
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyExcludeKeywordsToQualification"
              true-value="true"
              false-value="false")
            span 応募資格
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyExcludeKeywordsToCompanyName"
              true-value="true"
              false-value="false")
            span 事業所名
      .search-button
        input.button-main(
          type="button"
          @click="search"
          value="集計する"
          :disabled="locked")
        input.button-secondary(
          type="button"
          @click="toSearchConditions"
          value="保存した条件"
          :disabled="locked")
        span
          a(@click="showSearchConditionModal") 条件を保存
</template>

<script>
  import { mapGetters } from 'vuex'
  import Datepicker from 'vuejs-datepicker'
  import { ja } from 'vuejs-datepicker/dist/locale'
  import moment from 'moment'
  import {
    aggSalaryTypes,
    DefaultApplyKeywordsToCatchcopy,
    DefaultApplyKeywordsToJobtypeName,
    DefaultApplyKeywordsToJobContents,
    DefaultApplyKeywordsToQualification,
    DefaultApplyKeywordsToCompanyName,
    DefaultApplyExcludeKeywordsToCatchcopy,
    DefaultApplyExcludeKeywordsToJobtypeName,
    DefaultApplyExcludeKeywordsToJobContents,
    DefaultApplyExcludeKeywordsToQualification,
    DefaultApplyExcludeKeywordsToCompanyName,
    maxKeywords,
    recommendedExcludeKeywords,
  } from '../../constants'
  import mapGetSet from '../../libs/map-get-set'
  import aggregateJob from '../../store/modules/aggregateJob'
  import PrefectureCityModal from '../parts/PrefectureCityModal'
  import MultipleSelect from '../parts/MultipleSelect'
  import JobtypeModal from '../parts/JobtypeModal'

  export default {
    components: { JobtypeModal, PrefectureCityModal, MultipleSelect, Datepicker },
    props: ['openSidebar'],
    beforeCreate () {
      this.aggSalaryTypes = aggSalaryTypes
      this.maxKeywords = maxKeywords
    },
    data () {
      const {
        salaryCd = '0',
        rangeType = '2',
        aggType = '1',
        verticalAxis = '1',
        prefectureCd = '',
        cityCd = '',
        employmentCd = '',
        jobtypeCd = '',
        industryCd = '',
        workPlacePrefectureCd = '',
        workPlaceCityCd = '',
        mediaCd = '',
        keyword = '',
        excludeKeyword = '',
        aggregationFromDate = this.setDefaultAggregationFromDate(),
        aggregationToDate = this.setDefaultAggregationToDate(),
        applyKeywordsToCatchcopy = DefaultApplyKeywordsToCatchcopy,
        applyKeywordsToJobtypeName = DefaultApplyKeywordsToJobtypeName,
        applyKeywordsToJobContents = DefaultApplyKeywordsToJobContents,
        applyKeywordsToQualification = DefaultApplyKeywordsToQualification,
        applyKeywordsToCompanyName = DefaultApplyKeywordsToCompanyName,
        applyExcludeKeywordsToCatchcopy = DefaultApplyExcludeKeywordsToCatchcopy,
        applyExcludeKeywordsToJobtypeName = DefaultApplyExcludeKeywordsToJobtypeName,
        applyExcludeKeywordsToJobContents = DefaultApplyExcludeKeywordsToJobContents,
        applyExcludeKeywordsToQualification = DefaultApplyExcludeKeywordsToQualification,
        applyExcludeKeywordsToCompanyName = DefaultApplyExcludeKeywordsToCompanyName,
      } = this.$route.query

      const master = this.$store.state.master
      this.salaryCd = salaryCd
      this.rangeType = rangeType
      this.aggType = aggType
      this.verticalAxis = verticalAxis
      this.prefectureCd = this.toObjects(prefectureCd, master.prefectures)
      this.cityCd = this.toObjects(cityCd, master.cities)
      this.employmentCd = this.toObjects(employmentCd, master.employments)
      this.jobtypeCd = this.toObjects(jobtypeCd, master.jobtypes)
      this.industryCd = this.toObjects(industryCd, master.industries)
      this.workPlacePrefectureCd = this.toObjects(workPlacePrefectureCd, master.prefectures)
      this.workPlaceCityCd = this.toObjects(workPlaceCityCd, master.cities)
      this.mediaCd = this.toObjects(mediaCd, master.mediaForJobs)
      this.keyword = this.toKeywordObjects(keyword)
      this.excludeKeyword = this.toExcludeKeywordObjects(excludeKeyword)
      this.aggregationFromDate = aggregationFromDate
      this.aggregationToDate = aggregationToDate
      this.applyKeywordsToCatchcopy = applyKeywordsToCatchcopy
      this.applyKeywordsToJobtypeName = applyKeywordsToJobtypeName
      this.applyKeywordsToJobContents = applyKeywordsToJobContents
      this.applyKeywordsToQualification = applyKeywordsToQualification
      this.applyKeywordsToCompanyName = applyKeywordsToCompanyName
      this.applyExcludeKeywordsToCatchcopy = applyExcludeKeywordsToCatchcopy
      this.applyExcludeKeywordsToJobtypeName = applyExcludeKeywordsToJobtypeName
      this.applyExcludeKeywordsToJobContents = applyExcludeKeywordsToJobContents
      this.applyExcludeKeywordsToQualification = applyExcludeKeywordsToQualification
      this.applyExcludeKeywordsToCompanyName = applyExcludeKeywordsToCompanyName

      return {
        filteredStations: [],
        openJobtypeModal: false,
        openPrefectureModal: false,
        openWorkPlacePrefectureModal: false,
        keyDownCode: '',
        timeoutId: null,
        ja,
        disabledFromDates: {
          to: new Date(moment(aggregationToDate).subtract((31 * 6), 'd').format('YYYY-MM-DD')),
          from: new Date(moment(aggregationToDate).format('YYYY-MM-DD')),
        },
        disabledToDates: {
          to: new Date(moment(aggregationFromDate).format('YYYY-MM-DD')),
          from: new Date(moment(aggregationFromDate).add((31 * 6), 'd').format('YYYY-MM-DD')),
        },
      }
    },
    computed: {
      ...mapGetters({
        apiQuery: 'aggregateJob/apiQuery',
        locked: 'common/isGlobalLocked',
      }),
      ...mapGetSet({
        _this: this,
        get: ($vm, $s, k) => $s.state.aggregateJob.query[k],
        set: ($vm, $s, k, v) => $s.commit(`aggregateJob/${k}`, v),
        keys: Object.keys(aggregateJob.state.query),
      }),
      vSelectEmploymentCd () {
        return this.$store.state.master.employments.map(e => ({ label: e.name, value: e.code }))
      },
      vSelectIndustry () {
        return this.$store.state.master.industries.map(i => ({ label: i.name, value: i.code }))
      },
      vSelectMedia () {
        return this.$store.state.master.mediaForJobs.map(m => ({ label: m.name, value: m.code }))
      },
    },
    methods: {
      async search () {
        const { name } = this.$route

        try {
          this.$router.push({
            name,
            query: {
              ...this.apiQuery,
            },
          })
        } finally {
          this.$emit('toggleSidebar')
          this.$store.commit('common/unlockGlobal')
        }
      },
      setDefaultAggregationFromDate () {
        return moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')
      },
      setDefaultAggregationToDate () {
        return moment(new Date()).format('YYYY-MM-DD')
      },
      customFormatter (date) {
        return moment(date).format('YYYY-MM-DD')
      },
      pickerClosedChange () {
        if (this.aggregationFromDate) {
          this.aggregationFromDate = moment(this.aggregationFromDate).format('YYYY-MM-DD')
          this.disabledToDates.to = new Date(moment(this.aggregationFromDate).format('YYYY-MM-DD'))
          this.disabledToDates.from = new Date(moment(this.aggregationFromDate).add((31 * 6), 'd').format('YYYY-MM-DD'))
        }
        if (this.aggregationToDate) {
          this.aggregationToDate = moment(this.aggregationToDate).format('YYYY-MM-DD')
          this.disabledFromDates.from = new Date(moment(this.aggregationToDate).format('YYYY-MM-DD'))
          this.disabledFromDates.to = new Date(moment(this.aggregationToDate).subtract((31 * 6), 'd').format('YYYY-MM-DD'))
        }
      },
      hidePrefectureModal () {
        this.openPrefectureModal = false
      },
      hideJobtypeModal () {
        this.openJobtypeModal = false
      },
      hideWorkPlacePrefectureModal () {
        this.openWorkPlacePrefectureModal = false
      },
      togglePrefectureModal (e) {
        e.stopPropagation()
        this.openPrefectureModal = !this.openPrefectureModal
      },
      toggleJobtypeModal (e) {
        e.stopPropagation()
        this.openJobtypeModal = !this.openJobtypeModal
      },
      toggleWorkPlacePrefectureModal (e) {
        e.stopPropagation()
        this.openWorkPlacePrefectureModal = !this.openWorkPlacePrefectureModal
      },
      applyRecommendedExcludeKeywords (e) {
        e.stopPropagation()
        this.excludeKeyword = this.toExcludeKeywordObjects(recommendedExcludeKeywords)
      },
      prevSixMonths (e) {
        e.stopPropagation()

        this.aggregationFromDate = moment(this.aggregationFromDate).subtract(6, 'month').format('YYYY-MM-DD')
        if (this.needsDateFix()) {
          this.aggregationToDate = moment(this.aggregationToDate).subtract(6, 'month').endOf('month').format('YYYY-MM-DD')
        } else {
          this.aggregationToDate = moment(this.aggregationToDate).subtract(6, 'month').format('YYYY-MM-DD')
        }
        this.resetDisabledDates()
      },
      nextSixMonths (e) {
        e.stopPropagation()

        this.aggregationFromDate = moment(this.aggregationFromDate).add(6, 'month').format('YYYY-MM-DD')
        if (this.needsDateFix()) {
          this.aggregationToDate = moment(this.aggregationToDate).add(6, 'month').endOf('month').format('YYYY-MM-DD')
        } else {
          this.aggregationToDate = moment(this.aggregationToDate).add(6, 'month').format('YYYY-MM-DD')
        }
        this.resetDisabledDates()
      },
      needsDateFix () {
        const endOfMonth = moment(this.aggregationToDate)
        const toDate = endOfMonth.format('DD')
        return ((moment(this.aggregationFromDate).format('DD') === '01') && (toDate === endOfMonth.endOf('month').format('DD')))
      },
      resetDisabledDates () {
        this.disabledToDates.to = new Date(moment(this.aggregationFromDate).format('YYYY-MM-DD'))
        this.disabledToDates.from = new Date(moment(this.aggregationFromDate).add((31 * 6), 'd').format('YYYY-MM-DD'))

        this.disabledFromDates.from = new Date(moment(this.aggregationToDate).format('YYYY-MM-DD'))
        this.disabledFromDates.to = new Date(moment(this.aggregationToDate).subtract((31 * 6), 'd').format('YYYY-MM-DD'))
      },
      async setPrefectureCodes (prefectureCodes) {
        this.openPrefectureModal = false
        this.prefectureCd = prefectureCodes
      },
      async setCityCodes (cityCodes) {
        this.openPrefectureModal = false
        this.cityCd = cityCodes
      },
      async setJobtypeCodes (jobtypeCodes) {
        this.openJobtypeModal = false
        this.jobtypeCd = jobtypeCodes
      },
      async setWorkPlacePrefectureCodes (prefectureCodes) {
        this.openWorkPlacePrefectureModal = false
        this.workPlacePrefectureCd = prefectureCodes
      },
      async setWorkPlaceCityCodes (cityCodes) {
        this.openWorkPlacePrefectureModal = false
        this.workPlaceCityCd = cityCodes
      },
      toObjects (ids, masterData) {
        if (!ids) {
          return []
        }

        const isNumber = typeof masterData[0].code === 'number'
        return ids.split(',').reduce((list, id) => {
          const data = isNumber ?
            masterData.find(d => d.code === Number(id)) :
            masterData.find(d => d.code === id)
          if (data) {
            list.push({ label: data.name, value: data.code })
          }
          return list
        }, [])
      },
      toExcludeKeywordObjects (words) {
        if (!words) {
          return []
        }
        return words.split(',')
      },
      toKeywordObjects (words) {
        if (!words) {
          return []
        }
        return words.split(',')
      },
      toSearchConditions () {
        this.$router.push({ name: 'AggJobSearchConditions' })
      },
      async showSearchConditionModal (e) {
        e.stopPropagation()

        const condition = {
          salaryCd: this.salaryCd,
          rangeType: this.rangeType,
          aggType: this.aggType,
          verticalAxis: this.verticalAxis,
          prefectureCd: this.prefectureCd.map(({ value }) => value),
          cityCd: this.cityCd.map(({ value }) => value),
          employmentCd: this.employmentCd.map(({ value }) => value),
          jobtypeCd: this.jobtypeCd.map(({ value }) => value),
          industryCd: this.industryCd.map(({ value }) => value),
          workPlacePrefectureCd: this.workPlacePrefectureCd.map(({ value }) => value),
          workPlaceCityCd: this.workPlaceCityCd.map(({ value }) => value),
          mediaCd: this.mediaCd.map(({ value }) => value),
          keyword: this.keyword,
          excludeKeyword: this.excludeKeyword,
          aggregationFromDate: this.aggregationFromDate,
          aggregationToDate: this.aggregationToDate,
          applyKeywordsToCatchcopy: this.applyKeywordsToCatchcopy,
          applyKeywordsToJobtypeName: this.applyKeywordsToJobtypeName,
          applyKeywordsToJobContents: this.applyKeywordsToJobContents,
          applyKeywordsToQualification: this.applyKeywordsToQualification,
          applyKeywordsToCompanyName: this.applyKeywordsToCompanyName,
          applyExcludeKeywordsToCatchcopy: this.applyExcludeKeywordsToCatchcopy,
          applyExcludeKeywordsToJobtypeName: this.applyExcludeKeywordsToJobtypeName,
          applyExcludeKeywordsToJobContents: this.applyExcludeKeywordsToJobContents,
          applyExcludeKeywordsToQualification: this.applyExcludeKeywordsToQualification,
          applyExcludeKeywordsToCompanyName: this.applyExcludeKeywordsToCompanyName,
        }

        this.$store.dispatch('aggJobSearchCondition/fetchIndex')
        this.$store.dispatch('aggJobSearchCondition/setConditions', { condition })
        this.$store.commit('aggJobSearchCondition/showAggJobSearchConditionModal')
      },
      excludeKeywordEnter (e) {
        if (e.which === 13 && e.which === this.keyDownCode) {
          if (typeof e.target.value === 'string' && e.target.value.trim() !== '') {
            this.addExcludeKeyword(e.target.value.trim())
            e.target.value = ''
          }
        }
      },
      keywordEnter (e) {
        if (e.which === 13 && e.which === this.keyDownCode) {
          if (typeof e.target.value === 'string' && e.target.value.trim() !== '') {
            this.addKeyword(e.target.value.trim())
            e.target.value = ''
          }
        }
      },
      addExcludeKeyword (str) {
        if (this.excludeKeyword.length === this.maxKeywords) {
          // eslint-disable-next-line no-alert
          return alert(`除外キーワードは${this.maxKeywords}個までです。`)
        }
        this.$store.commit('aggregateJob/addExcludeKeyword', str)
      },
      addKeyword (str) {
        if (this.keyword.length === this.maxKeywords) {
          // eslint-disable-next-line no-alert
          return alert(`キーワードは${this.maxKeywords}個までです。`)
        }
        this.$store.commit('aggregateJob/addKeyword', str)
      },
      removeExcludeKeyword (index) {
        this.$store.commit('aggregateJob/removeExcludeKeyword', index)
      },
      removeKeyword (index) {
        this.$store.commit('aggregateJob/removeKeyword', index)
      },
      async keydownCondition (e) {
        this.keyDownCode = e.which
      },
    },
    watch: {
      $route () {
        Object.assign(this.$data, this.$options.data.apply(this))
      },
      salaryCd (newSalaryCd) {
        // 給与形態全ての場合は給与の集計は不可
        if (newSalaryCd === '0' && this.aggType === '2') {
          this.aggType = '1'
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/JobAggregateSidebar.vue